var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGlobal17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.86541 18C14.7616 18 18.7308 14.1944 18.7308 9.5C18.7308 4.80558 14.7616 1 9.86541 1C4.96918 1 1 4.80558 1 9.5C1 14.1944 4.96918 18 9.86541 18Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1 9.49995H18.7308",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.8655 1C12.083 3.3276 13.3432 6.34823 13.4117 9.5C13.3432 12.6518 12.083 15.6724 9.8655 18C7.64801 15.6724 6.38782 12.6518 6.31934 9.5C6.38782 6.34823 7.64801 3.3276 9.8655 1Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlobal17);
export default __webpack_public_path__ + "static/media/icon_global_17.64c8bddbaace8d463e273792af87bc4c.svg";
export { ForwardRef as ReactComponent };